<template>
    <DModal
        :title="__('customers.contracts.change_price')"
        is-confirm
        is-big
        overflow-auto
        :show="showModal"
        @confirm="$emit('save-price', priceData)"
        @close="$emit('close-modal')"
    >
        <div class="modal-content-padding">
            <PhaseStartDate
                v-model="priceData.start_date"
                :errors="errors"
                :disabled="disableStartDateChange"
                :id-suffix="idSuffix"
            />

            <BillingCycle
                v-if="isSelectedPlanOneTime === false"
                v-model="priceData.billing_cycle"
                :errors="errors"
                :billing-cycles="billingCycles"
                :id-suffix="idSuffix"
            />

            <Price
                v-model="priceData.price"
                :errors="errors"
                :id-suffix="idSuffix"
            />

            <ThirdPartyCost
                v-model="priceData.third_party_cost"
                :errors="errors"
                :id-suffix="idSuffix"
            />

            <Discount
                v-model:discountName="priceData.discount_name"
                v-model:discountValue="priceData.discount_value"
                v-model:discountType="priceData.discount_type"
                :errors="errors"
                :discount-types="discountTypes"
                :id-suffix="idSuffix"
            />

            <SetupFee
                v-if="isSelectedPlanOneTime === false && priceData.billing_cycle !== null"
                v-model="priceData.setup_fee"
                class="pt-4"
                :errors="errors"
            />

            <PhaseText
                v-model="priceData.phase_text"
                :errors="errors"
            />
        </div>
    </DModal>
</template>

<script>
import BillingCycle from '~@/Components/Customers/Contracts/FormFields/BillingCycle.vue'
import Price from '~@/Components/Customers/Contracts/FormFields/Price.vue'
import Discount from '~@/Components/Customers/Contracts/FormFields/Discount.vue'
import PhaseStartDate from '~@/Components/Customers/Contracts/FormFields/PhaseStartDate.vue'
import _ from 'lodash'
import ThirdPartyCost from '~@/Components/Customers/Contracts/FormFields/ThirdPartyCost.vue'
import SetupFee from '~@/Components/Customers/Contracts/FormFields/SetupFee.vue'
import PhaseText from '../FormFields/PhaseText.vue'

export default {
    name: 'PriceModal',
    components: { PhaseText, ThirdPartyCost, PhaseStartDate, Discount, Price, BillingCycle, SetupFee },
    props: {
        price: {
            type: Object,
            default: () => { return {} }
        },
        showModal: {
            type: Boolean,
            default: false
        },
        disableStartDateChange: {
            type: Boolean,
            default: false
        },
        errorsData: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        isSelectedPlanOneTime: {
            type: Boolean,
            default: false
        },
        index: {
            type: Number,
            default: null
        }
    },
    emits: ['save-price', 'close-modal'],
    data () {
        return {
            errors: this.errorsData,
            priceData: _.cloneDeep(this.price)
        }
    },
    computed: {
        idSuffix () {
            return this.index === null ? '_price_add' : `_price_edit_${this.index}`
        }
    }
}
</script>

<style scoped>
.modal-content-padding {
    padding: 31px 20px !important;
}
</style>
